import {
  borderRadius,
  customScrollMinimal,
  Input,
  typographyV2,
} from '@toggle/design-system';
import styled from 'styled-components';

export const LinkInputRoot = styled.div`
  margin-top: 32px;
`;

export const StyledInput = styled(Input)`
  [data-input-wrapper] {
    padding-right: 4px;
    background-color: var(--background-default);
  }
`;

export const InputLabel = styled.span`
  ${typographyV2.bodySm};
  margin-bottom: 4px;
`;

export const InputWrapper = styled.div`
  position: relative;
`;

export const TextareaElement = styled.textarea`
  padding: 8px 12px;
  border: 1px solid var(--border-default);
  width: 100%;
  ${borderRadius.r1};
  ${customScrollMinimal};
  ${typographyV2.bodyBase};
  max-height: 240px;
  resize: none;

  &:hover {
    border: 1px solid var(--border-hover);
  }

  &:focus {
    border: 1px solid var(--border-primary);
  }
`;
